<template>
  <div class="testimony">
    <div class="testimony__img">
      <img :src="image" :alt="`${$t('alt.picture')}`">
    </div>
    <div class="testimony__text">
      <p>
        <span class="relative">
          {{ firstWord }}
          <span class="testimony__quotes testimony__quotes--left">
            <font-awesome-icon icon="quote-left" />
          </span>
        </span>
        {{ filteredText }}
        <span class="relative">
          {{ lastWord }}
          <span class="testimony__quotes testimony__quotes--right">
            <font-awesome-icon icon="quote-right" />
          </span>
        </span>
      </p>
    </div>
    <p class="testimony__author">
      {{ fullName }}
    </p>
  </div>
</template>
<script>

export default {
  name: 'TestimonyItem',
  data () {
    return {
      filteredText: undefined,
      firstWord: undefined,
      lastWord: undefined,
      fullName: undefined
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  created () {
    const wordsArr = this.text.split(' ')
    this.firstWord = wordsArr[0]
    wordsArr.splice(0, 1)
    const lastWordIndex = wordsArr.length - 1
    this.lastWord = wordsArr[lastWordIndex]
    wordsArr.pop()
    this.filteredText = wordsArr.join(' ')
  }
}
</script>
<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities

.testimony
  @apply text-white
  &__img
    @apply relative w-24 h-24 mx-auto
    img
      @apply rounded-full
    &::after
      @apply no-content absolute half-t half-l -translate-xy-50 border-4 border-pink rounded-full
      width: 120%
      height: 120%
  &__text
    @apply relative text-center mt-2
  &__quotes
    @apply absolute text-lg text-pink
    &--left
      top: -3px
      left: -27px
    &--right
      bottom: -3px
      right: -28px
  &__author
    @apply text-center text-lg text-pink font-bold mt-2

/* purgecss end ignore */
</style>
